/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from 'react';
import { numberWithCommas, formatSku } from "utilities/helper";
import http from 'utilities/http';
import { isArray } from 'lodash';

export default function SlideImage({ id, tag: tagP, tagShowingId, setTagShowingId }) {
    const [tag, setTag] = useState(tagP);
    const [isShow, setIsShow] = useState(tagShowingId === tag?.id || tagShowingId === tag?.product_id ? true : false);
    const [imgUrl, setimgUrl] = useState(tagShowingId === tag?.id || tagShowingId === tag?.product_id ? '/images/Bookmark.svg' : '/images/Bookmark-white.svg');

    useEffect(() => setTag(tagP), [tagP]);
    useEffect(() => {
        setIsShow(tagShowingId === tag.id || tagShowingId === tag?.product_id ? true : false);
        setimgUrl(tagShowingId === tag?.id || tagShowingId === tag?.product_id ? '/images/Bookmark.svg' : '/images/Bookmark-white.svg');
    }, [tagShowingId]);

    let tagPosition = [];
    if (isArray(tag?.position)) {
        tagPosition = tag.position;
    } else {
        tagPosition = JSON.parse(tag.position);
    }

    const location = {
        top: tagPosition[1] + '%',
        left: tagPosition[0] + '%',
    };

    let fakePositionClass = "";
    if (+tagPosition[0] < 20) fakePositionClass += "left-tag";
    if (+tagPosition[0] > 80) fakePositionClass += "right-tag";
    if (+tagPosition[1] > 78) fakePositionClass += "top-tag";

    const fetchData = async () => {
        const vendor = await http(`/rest/V1/products/vendor/${product.id}`, {}, { token: 'default' });
        product.vendor = vendor.company || vendor.shop_name || vendor.name || vendor.vendor_id;
        product.vendorLogo = vendor.logo || "/images/icon-app.svg";
    };

    const onClickTag = async () => {
        if (isShow) {
            setIsShow(false);
            setTagShowingId(null);
            setimgUrl('/images/Bookmark-white.svg');
            return;
        }

        // if (!tag) {
        //     await fetchData();
        // }
        setIsShow(true);
        setTagShowingId(tag.id || tag.product_id);
        setimgUrl('/images/Bookmark.svg');
    };

    return (
        <div key={id} className="photoLocation" style={location}>
            <span
                className={isShow ? "item item--box" : "item"}
                onClick={onClickTag}
            >
                <img src={imgUrl} alt="" />
            </span>

            {isShow && (<div className={`photoLocation-sub photoLocation-sub--mw242 ` + fakePositionClass}>
                <div className="photoLocation-pro">
                    <div className="photoLocation-pro_thumb wrap-next-image">
                        <img src={tag?.avatar_url || tag?.product_image} alt="" />
                    </div>
                    <div className="photoLocation-pro_info">
                        <h4 className="tlt"><a href={'/shop/' + (formatSku(tag?.sku || tag?.product_id)) + `/${formatSku(tag?.name)}` + '.html'} target="_blank" rel="noreferrer">{(tag?.name || tag?.product_name)}</a></h4>
                        <p className="lable-text">
                            <span className="price">{numberWithCommas(tag?.price || tag?.product_price)}đ</span>
                            {tag?.old_price && <span className="discount" style={{ color: '#666', textDecoration: 'line-through' }}>{numberWithCommas(tag?.old_price)}đ</span>}

                            {/* <span className="view">{tag?.extension_attributes.rating_summary}<img src="/images/icon-star.svg" alt="" /></span> */}
                        </p>
                        {/* <div className="brand">
                            <span><img src={tag?.vendorLogo} alt="" /></span>
                            {tag?.vendor}
                        </div> */}
                    </div>
                </div>
            </div>)}
        </div>
    );
};